import { config } from '@config/config';
import * as i0 from "@angular/core";
export class JwtService {
    constructor() { }
    getTokenId(token) {
        const jwt = this.decodeToken(token);
        return jwt[config.tokenIds[jwt.type]];
    }
    getScopes(token) {
        const jwt = this.decodeToken(token);
        return typeof jwt.scope === 'string' ? [jwt.scope] : jwt.scope;
    }
    getBaseUrl(token) {
        const jwt = this.decodeToken(token);
        return jwt ? `${config.baseUrls[jwt.type]}/${jwt.user_id}` : '';
    }
    decodeToken(token) {
        if (!token || token === '') {
            return;
        }
        const parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error("The inspected token doesn't appear to be a JWT." +
                'Check to make sure it has three parts and see https://jwt.io for more.');
        }
        const decoded = this.urlBase64Decode(parts[1]);
        if (!decoded) {
            throw new Error('Cannot decode the token.');
        }
        return JSON.parse(decoded);
    }
    getTokenExpirationDate(token) {
        const decoded = typeof token === 'string' ? this.decodeToken(token) : token;
        if (decoded === null) {
            return null;
        }
        if (!decoded.hasOwnProperty('exp')) {
            return null;
        }
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }
    isTokenExpired(token, offsetSeconds) {
        const date = this.getTokenExpirationDate(token);
        offsetSeconds = offsetSeconds || 0;
        if (date === null) {
            return true;
        }
        return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    }
    urlBase64Decode(str) {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: {
                break;
            }
            case 2: {
                output += '==';
                break;
            }
            case 3: {
                output += '=';
                break;
            }
            default: {
                throw new Error('Illegal base64url string!');
            }
        }
        return this.b64DecodeUnicode(output);
    }
    // credits for decoder goes to https://github.com/atk
    b64decode(str) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output = '';
        str = String(str).replace(/=+$/, '');
        if (str.length % 4 === 1) {
            throw new Error('"atob" failed: The string to be decoded is not correctly encoded.');
        }
        for (
        // initialize result and counters
        let bc = 0, bs, buffer, idx = 0; 
        // get next character
        (buffer = str.charAt(idx++)); 
        // character found in table? initialize bit storage and add its ascii value;
        // eslint-disable-next-line no-bitwise
        ~buffer &&
            ((bs = bc % 4 ? bs * 64 + buffer : buffer),
                // and if not first of each 4 characters,
                // convert the first 8 bits to one ascii character
                bc++ % 4)
            ? // eslint-disable-next-line
                (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
            : 0) {
            // try to find character in table (0-63, not found => -1)
            buffer = chars.indexOf(buffer);
        }
        return output;
    }
    b64DecodeUnicode(str) {
        return decodeURIComponent(Array.prototype.map
            .call(this.b64decode(str), (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''));
    }
}
JwtService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function JwtService_Factory() { return new JwtService(); }, token: JwtService, providedIn: "root" });
